import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from './features/layout/layout.module';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';

import localeFr from '@angular/common/locales/fr';
import { environment } from '../environments/environment';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { UntypedFormBuilder } from '@angular/forms';
import { NgxStripeModule } from 'ngx-stripe';
import {
    DateAdapter,
    MAT_DATE_FORMATS,
    MAT_DATE_LOCALE,
    MatNativeDateModule,
} from '@angular/material/core';
import {
    LuxonDateAdapter,
    MAT_LUXON_DATE_ADAPTER_OPTIONS,
    MAT_LUXON_DATE_FORMATS,
} from '@angular/material-luxon-adapter';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { GuidedTourModule, GuidedTourService } from 'ngx-guided-tour';
import { MAT_SELECT_SCROLL_STRATEGY } from '@angular/material/select';
import { Overlay } from '@angular/cdk/overlay';

registerLocaleData(localeFr);

/**
 * Configuration de Firebase - Authentification via google/fb/...
 */
const firebaseConfig = {
    apiKey: 'AIzaSyDWUa07Vljf6_QwUZA2bi4-UKAeJlSxNuY',
    authDomain: 'wanview-store.firebaseapp.com',
    projectId: 'wanview-store',
    storageBucket: 'wanview-store.appspot.com',
    messagingSenderId: '1047775373251',
    appId: '1:1047775373251:web:215f9ddbd8cc6a03ef7f76',
    measurementId: 'G-X0CY2J5Q9Q',
};

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(
        http,
        environment.apiBaseUrl + '/culture/',
        ''
    );
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        LayoutModule,
        BrowserAnimationsModule,
        MatDialogModule,
        HttpClientModule,
        MatSnackBarModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        AngularFireModule.initializeApp(firebaseConfig),
        AngularFireAuthModule,
        NgxStripeModule.forRoot(environment.stripePublicKey),
        MatNativeDateModule,
        GuidedTourModule,
    ],
    providers: [
        UntypedFormBuilder,
        provideCharts(withDefaultRegisterables()),
        { provide: MAT_DATE_LOCALE, useValue: 'default' },
        { provide: MAT_LUXON_DATE_ADAPTER_OPTIONS, useValue: { firstDayOfWeek: 1 } },
        {
            provide: DateAdapter,
            useClass: LuxonDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_LUXON_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS },
        GuidedTourService,
        {
            provide: MAT_SELECT_SCROLL_STRATEGY,
            useFactory: (overlay: Overlay) => () => overlay.scrollStrategies.block(),
            deps: [Overlay]
          }
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
